import axios from "axios";

export const BASE_URL_API = `${process.env.REACT_APP_DIKIGO_API}`;
export const LOGIN_URL = `${BASE_URL_API}/admin/auth/login`;
export const REGISTER_URL = `${BASE_URL_API}/admin/auth/register`;
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

export const ME_URL = `${BASE_URL_API}/admin/users/me`;

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}

export function register({ email, fullname, username, password, isAdmin }) {
  return axios.post(REGISTER_URL, { email, fullname, username, password, isAdmin });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}
